/*
 * @description: 系统路由配置
 * @author: xuy
 * @since: 2020-03-31 11:03:46
 * @version: 1.0
 */
import PublicLayout from '@/framework/layout2/PublicLayout.vue'
export default [
  {
    path: '/service-center',
    component: PublicLayout,
    children: [
      {
        path: 'index',
        component: () => import('@/app/service-center/views/index'),
        name: 'ServiceCenter',
        meta: { title: 'module.service-center.098679-0', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
      }
    ]
  }
]
